import { createGameApiClient } from "./gameApi";

type RaffleAvailabilityResponse = {
  available: boolean;
  should_skip_share_and_raffle: boolean;
  already_claimed: boolean;
  result?: "win" | "lose" | null;
  campaign_id?: string | null;
  campaign_name?: string | null;
  campaign_information?: string | null;
  remaining_win_count?: number;
};

type RaffleClaimResponse = {
  result: "win" | "lose";
  already_claimed: boolean;
  campaign_id?: string | null;
  campaign_name?: string | null;
  campaign_information?: string | null;
  claim_rejected_reason?: string | null;
  remaining_win_count?: number;
  claimed_win_count?: number;
};

export const getRaffleAvailability = async (
  gameId: string,
  identifier: string
) => {
  const client = createGameApiClient();
  const { data } = await client.get<RaffleAvailabilityResponse>(
    `public/games/${gameId}/sessions/${identifier}/raffle/availability`
  );

  return data;
};

export const claimRaffleResult = async (gameId: string, identifier: string) => {
  const client = createGameApiClient();
  const { data } = await client.post<RaffleClaimResponse>(
    `public/games/${gameId}/sessions/${identifier}/raffle/claim`
  );

  return data;
};
